export default "__VITE_ASSET__DV_k4y0B__"